// extracted by mini-css-extract-plugin
export default {"btn":"ScrollToTop_btn__k7DRl","visible":"ScrollToTop_visible__W5dEo","img":"ScrollToTop_img__+ct1K"};